define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'internal_util/Configuration',
	'internal_util/StorageUtil',
	'state/UIState',
	'model/AuthenticationOptionGroup',
	'model/RequestedAttribute',
	'service/UIStateManager',
	'view/ProviderInfoView',
	'view/NavigationView',
	'view/PrivacyPolicyView',
	'view/ControlBarView',
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/PrivacyPolicyState_strings'
], function (
	Util,
	UiUtil,
	Configuration,
	StorageUtil,
	UIState,
	AuthenticationOptionGroup,
	RequestedAttribute,
	UIStateManager,
	ProviderInfoView,
	NavigationView,
	PrivacyPolicyView,
	ControlBarView,
	CommonStrings,
	Strings
) {
	'use strict';

	/**
	 * PrivacyPolicyState class
	 */
	function PrivacyPolicyState(uiStateManager) {
		var _uiStateManager,
			_providerInfoView = new ProviderInfoView(),
			_navigationView = new NavigationView(),
			_privacyPolicyView = new PrivacyPolicyView(),
			_controlBarView = new ControlBarView('skIdS_control-bar-privacy-policy'),
			_consentCheckBox,
			_nextButton,
			_activationData = null,
			_skipAttributeSelection = false;

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

		_navigationView.update(Strings.privacy_policy_skidentity);

		_consentCheckBox = _controlBarView.addCheckBox(Strings.approval_checkbox, function (isChecked) {
			_nextButton.prop('disabled', !isChecked);
		});

		_controlBarView.addButton(CommonStrings.back, function () {
			if (_activationData['fromSP']) {
				_uiStateManager.changeContext();
			} else {
				_uiStateManager.back();
			}
		}, 0);

		_nextButton = _controlBarView.addButton(CommonStrings.next, function () {
			if (_skipAttributeSelection) {
				_activationData['requestedAttributes'] = 
					_activationData['requestedAttributes'].concat(_activationData['authenticationOption'].requestedAttributes());
				_uiStateManager.change('activation', _activationData);
			} else {
				_uiStateManager.change('attributes_selection', _activationData);
			}
		});

		_controlBarView.addButton(CommonStrings.abort, function () {
			StorageUtil.remove('authentication_option');

			_uiStateManager.abort();
		});

		UIState.call(this, 'privacy_policy');


		// private methods

		function checkSkipAttributeSelection(authenticationOption) {
			var disabledAttributeSelection = Configuration.get('EID_CLIENT_ATTRIBUTE_SELECTION'),
				authenticationOptions,
				i;

			if (authenticationOption instanceof AuthenticationOptionGroup) {
				authenticationOptions = authenticationOption.authenticationOptions();

				for (i = 0; i < authenticationOptions.length; i++) {
					if (disabledAttributeSelection.indexOf(authenticationOptions[i].type()) === -1) {
						return false;
					}
				}

				return true;
			} else {
				return (disabledAttributeSelection.indexOf(authenticationOption.type()) !== -1);
			}
		}

		function replaceAttributes(requestedAttributes) {
			var filteredRequestedAttributes = new Array(),
				replaced = false,
				i;

			for (var i = 0; i < requestedAttributes.length; i++) {
				// TODO: use AttributesManager.keyword(name) to resolve attribute name (URI) to keyword first and
				//       then check for "Age" and "AgeVerification"
				if (Util.endsWith(requestedAttributes[i].name(), '/Age')
						|| Util.endsWith(requestedAttributes[i].name(), '/AgeVerification')) {
					if (!replaced) {
						replaced = true;

						filteredRequestedAttributes.push(new RequestedAttribute('http://www.skidentity.de/att/DateOfBirth',
								requestedAttributes[i].isRequired(),
								requestedAttributes[i].purpose()));
					}
				} else {
					filteredRequestedAttributes.push(requestedAttributes[i]);
				}
			}

			return filteredRequestedAttributes;
		}


		// public methods

		this.title = function () {
			return _uiStateManager.core().cloudIdentitiesManager().providerInfo().description();
		};
		
		this.poweredByImage = function () {
			if (_uiStateManager.core().optionsManager() === null || _uiStateManager.core().optionsManager() === undefined) {
				return null;
			}
			return _uiStateManager.core().optionsManager().providerInfo().poweredByImage();
		};

		this.content = function () {
			return [ _providerInfoView, _navigationView, _privacyPolicyView ];
		};

		this.controls = function () {
			return _controlBarView;
		};

		this.enter = function (doneCallback, activationData) {
			var cloudIdentitiesManager = _uiStateManager.core().cloudIdentitiesManager();

			_activationData = activationData;

			_activationData['requestedAttributes'] = replaceAttributes(_activationData['requestedAttributes']);

			if (_activationData['fromSP']) {
				_activationData['authenticationOption'] =
					cloudIdentitiesManager.getAuthenticationOptionByAuthenticationOption(_activationData['authenticationOption']);
			}

			_providerInfoView.update(cloudIdentitiesManager.providerInfo());

			_consentCheckBox.children('input').prop('checked', false);
			_nextButton.prop('disabled', true);

			if (_activationData.hasOwnProperty('revokation')) {
				_skipAttributeSelection = true;
				_nextButton.html(Strings.revoke_cloud_identities);
			} else if (checkSkipAttributeSelection(_activationData['authenticationOption'])) {
				_skipAttributeSelection = true;
				_nextButton.html(Strings.create_cloud_identity);
			} else {
				_skipAttributeSelection = false;
				_nextButton.html(CommonStrings.next);
			}
			
			var reqAttr = [];
			var reqAttrTest = _activationData['authenticationOption'].requestedAttributes();
			for (var attr in reqAttrTest) {
			    if (reqAttrTest[attr].isRequired()) {
				reqAttr.push(reqAttrTest[attr]);
			    }
			}
			//FIXE: if user goes back, the reqAttr in _activationDate gets copied
			if (reqAttr.length === reqAttrTest.length && 
				reqAttr.length === 1 &&
				reqAttr[0].name() === "http://www.skidentity.de/att/eIdentifier") {
			    //console.info("Skip ",reqAttr[0].name());
			    _skipAttributeSelection = true;
			}

			Util.callCallbacks(doneCallback);

			UiUtil.scrollTo(_navigationView.get());
		};

		this.leave = function (doneCallback) {
			_activationData = null;

			Util.callCallbacks(doneCallback);
		};
	}

	PrivacyPolicyState.prototype = Object.create(UIState.prototype);

	return PrivacyPolicyState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/PrivacyPolicyState.js
// module id = 353
// module chunks = 2